import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import MarkAsShippedHotkey from '../hotkeys/advanced-hotkeys/mark-as-shipped';

import { emptyArray } from 'ui-components/default-props/empty';
import MarkAsShippedBulkHotkey from '../hotkeys/advanced-hotkeys/mark-as-shipped-bulk';
import messages from './messages';
import style from './shared-classes.module.less';

const OtherActionButton = ({ children = null, otherActions = emptyArray }) => {
  return (
    <MarkAsShippedBulkHotkey>
      <MarkAsShippedHotkey>
        <DropdownMenu dropdownMenuClassName={style['dropdown-menu']} menuPosition='bottom-right'>
          <DropdownMenuToggler className={style['action-button']} theme='tertiary'>
            <FormattedMessage {...messages.otherActions} />
          </DropdownMenuToggler>
          {children}
          {otherActions.map(({ name, actionHandler, disabled }) => {
            return (
              <DropdownMenuItem key={name} disabled={disabled} onClick={actionHandler}>
                {name}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      </MarkAsShippedHotkey>
    </MarkAsShippedBulkHotkey>
  );
};

OtherActionButton.propTypes = {
  otherActions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      actionHandler: PropTypes.func,
      disabled: PropTypes.bool,
    }),
  ),
  children: PropTypes.node,
};

export default OtherActionButton;
